import type { IconButtonProps } from '@mui/material';
import MuiIconButton from '@mui/material/IconButton';
import type { ElementType } from 'react';
import { forwardRef } from 'react';

export interface ExtendedIconButtonProps extends IconButtonProps {
  to?: string;
  href?: string;
  component?: ElementType;
}

const IconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  (props, ref) => {
    return <MuiIconButton ref={ref} {...props} />;
  },
);

IconButton.displayName = 'Button';
export default IconButton;
